// import { get } from "lodash";

export default {
  getAdminSettings: (state) => state.settings.platformSettings,
  getAdminServiceAreas: (state) => state.settings.serviceAreas,
  selectEnterpriseAdminSettings: (state) => state.settings.enterpriseAdminSettings,
  getPowurPairWeights: (state) => state.settings.powurPairWeights,
  selectAdminAdvanceSettings: (state) => state.settings.payAdvanceSettings,
};
